<template>
    <div
        :class="{ 'cz2__is-kiosk': isKiosk }"
        class="cz2__scrollbar-hide cz2__color-selector"
    >
        <span class="cz2__sr-only">
            {{ $t('SR_ACTIVATING') }}
        </span>

        <color-selector-swatches
            ref="swatches"
            :colors="colors"
            class="cz2__color-selector-wrapper"
        />
    </div>
</template>

<style lang="scss">
    @import "../../style/variables.scss";

    #cz2.cz2 {
        .cz2__color-selector {
            max-width: 100%;
            overflow: auto;
            overflow-y: hidden;

            padding: 12px var(--layout-spacing) 0 var(--layout-spacing);

            display: flex;

            .cz2__color-selector-wrapper {
                display: flex;
                gap: 24px;
                align-self: center;
            }

            @include respond-above(md) {
                padding: 24px var(--layout-spacing) 8px var(--layout-spacing);
            }

            @include respond-above(lg) {
                .cz2__color-selector-wrapper {
                    flex-wrap: wrap;
                    row-gap: 10px;
                }
            }

            @include respond-above(2xl) {
                margin-top: -24px;
            }

            &.cz2__is-kiosk {
                padding-left: calc(2 * var(--layout-spacing));
            }
        }
    }
</style>

<script>
    import ColorSelectorSwatches from './ColorSelectorSwatches.vue';

    export default {
        components: {
            ColorSelectorSwatches,
        },

        props: {
            colors: {
                type: Array,
                default: () => [],
            },
        },

        data() {
            return {
                focusedButtonIndex: 0,
                hasKeyEventListener: false,
            };
        },

        mounted() {
            this.updateTabIndexes();
            this.addKeyDownListener();
        },

        updated() {
            this.updateTabIndexes();
        },

        beforeDestroy() {
            this.removeKeyDownListener();
        },

        computed: {
            isKiosk() {
                return this.$store.state.customizer.options.isKiosk;
            },
        },

        methods: {
            updateTabIndexes() {
                const buttonsWrapper = this.$refs.swatches.$el;
                const buttons = buttonsWrapper.getElementsByTagName('button');
                const focusedButton = buttons[this.focusedButtonIndex];

                buttons.forEach((button) => {
                    button.setAttribute('tabindex', -1);
                });

                if (focusedButton) {
                    focusedButton.setAttribute('tabindex', 0);
                }
            },

            addKeyDownListener() {
                if (!this.hasKeyEventListener) {
                    this.$refs.swatches.$el.addEventListener('keydown', this.captureNavKeyPress);
                    this.hasKeyEventListener = true;
                }
            },

            removeKeyDownListener() {
                this.$refs.swatches.$el.removeEventListener('keydown', this.captureNavKeyPress);
                this.hasKeyEventListener = false;
            },

            captureNavKeyPress(event) {
                const buttonsWrapper = this.$refs.swatches.$el;
                const buttons = buttonsWrapper.getElementsByTagName('button');
                const firstOption = buttons[0];
                const lastOption = buttons[buttons.length - 1];
                const focusedOptionElement = buttons[this.focusedButtonIndex];

                if (event.keyCode === 40 || event.keyCode === 39) {
                    // Down or right arrow key
                    event.preventDefault();

                    if (focusedOptionElement && buttons[this.focusedButtonIndex + 1]) {
                        this.focusedButtonIndex += 1;
                        this.updateTabIndexes();
                        buttons[this.focusedButtonIndex].focus();
                    } else {
                        this.focusedButtonIndex = 0;
                        this.updateTabIndexes();
                        firstOption.focus();
                    }
                } else if (event.keyCode === 38 || event.keyCode === 37) {
                    // Up or left arrow key
                    event.preventDefault();

                    if (focusedOptionElement && buttons[this.focusedButtonIndex - 1]) {
                        this.focusedButtonIndex -= 1;
                        this.updateTabIndexes();
                        buttons[this.focusedButtonIndex].focus();
                    } else {
                        this.focusedButtonIndex = buttons.length - 1;
                        this.updateTabIndexes();
                        lastOption.focus();
                    }
                }
            },
        },
    };
</script>
